import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout';
import AdminLayout from './layouts/AdminLayout';
import ProtectedRoute from './routes/ProtectedRoute';
import HomePage from './pages/HomePage';
import ComparePage from './pages/ComparePage';
import MapPage from './pages/MapPage';
import StationPage from './pages/StationPage';
import MethodologyPage from './pages/MethodologyPage';
import EuropePage from './pages/EuropePage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import ImportsPage from './pages/admin/ImportsPage';

export default function App() {
  return <BrowserRouter><Routes>
    <Route element={<PublicLayout />}>
      <Route index element={<HomePage />} />
      <Route path="confronta" element={<ComparePage />} />
      <Route path="mappa" element={<MapPage />} />
      <Route path="europa" element={<EuropePage />} />
      <Route path="impianti/:id" element={<StationPage />} />
      <Route path="metodologia" element={<MethodologyPage />} />
    </Route>
    <Route path="admin/login" element={<AdminLoginPage />} />
    <Route element={<ProtectedRoute />}><Route path="admin" element={<AdminLayout />}><Route index element={<AdminDashboardPage />} /><Route path="importazioni" element={<ImportsPage />} /></Route></Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></BrowserRouter>;
}
